import React from 'react';
import classNames from 'classnames';
import { useDocumentFieldSignerChange } from 'Hooks/DocumentFields';
import { SelectableOption } from 'Interfaces/Common';
import {
  DocumentField,
  DocumentFieldsCRUDMeta,
  DocumentFieldUpdatePayload,
} from 'Interfaces/DocumentFields';

interface FieldParticipantsListProps {
  isCheckable: boolean;
  field: DocumentField;
  signerId: string | null;
  signersOptions: SelectableOption<string>[];
  onUpdateDocumentField: (
    payload: Omit<DocumentFieldUpdatePayload, 'id'>,
    meta?: DocumentFieldsCRUDMeta,
  ) => void;
  onChangeSigner: (signerId: string) => void;
}

function FieldParticipantsList({
  isCheckable,
  field,
  signerId,
  signersOptions,
  onUpdateDocumentField,
  onChangeSigner,
}: FieldParticipantsListProps) {
  const changeDocumentFieldSigner = useDocumentFieldSignerChange(field);

  return (
    <ul className="fieldDropDown__list">
      {signersOptions.map(signerOption => (
        <li
          key={signerOption.value}
          className={classNames('fieldDropDown__item', {
            'fieldDropDown__item--checkable': isCheckable,
            'fieldDropDown__item--active': signerId === signerOption.value,
          })}
          onClick={() => {
            onChangeSigner(signerOption.value);
            const changePayload = changeDocumentFieldSigner(signerOption.value);
            if (changePayload) onUpdateDocumentField(changePayload);
          }}
        >
          {signerOption.label}
        </li>
      ))}
    </ul>
  );
}

export default FieldParticipantsList;
